import {
  LOADER,
  MODAL,
  FLOOR
} from '../../reduxs'

import apiService from '../apiService'

export const getListFloor = (param) => {
  return dispatch => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.get('rest/v1/getlist_floor', param).then(res => {
      if (res.status) {
        dispatch(saveListFloor(res.data.list))
      } else if (!res.status) {
        dispatch(MODAL.action.openModalStatus(res))
      } else {
        console.log('ERROR ACTION getListFloor', res)
      }
      dispatch(LOADER.action.displayLoader(false))
    })
  }
}

export const saveListFloor = (list) => {
  return {
    type: FLOOR.actionType.SAVE_LIST_FLOOR,
    list
  }
}

export const clearListFloor = () => {
  return {
    type: FLOOR.actionType.CLEAR_LIST_FLOOR
  }
}
